import React from 'react';

export const AboutSection: React.FC = () => {
  return (
    <section id="o-nas" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="flex items-center justify-center mb-8">
              <img 
                src="https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/922a6cc1bcbe4a849c9d8b3340221f4a.png" 
                alt="TopInstal Snajdr Logo" 
                className="max-w-md w-full h-auto object-contain scale-[1.2]"
              />
            </div>
          </div>
          
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              <strong>O nás</strong>
            </h2>
            <div className="space-y-6 text-gray-700">
              <p className="text-lg leading-relaxed">
                Jsme firma zabývající instalatérskými a topenářskými pracemi, fungujeme v Mladé Boleslavi a okolí, 
                ale po domluvě není problém zajet i dále. Ke každému zákazníkovi přistupujeme nejlépe jak umíme 
                a to samé platí i s naší prací.
              </p>
              
              <div className="grid grid-cols-2 gap-4 mt-8">
                <div className="bg-gray-50 rounded-lg p-4 flex flex-col h-full">
                  <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mb-3 flex-shrink-0">
                    <i className="ri-award-line text-white text-lg"></i>
                  </div>
                  <h3 className="text-base font-semibold text-gray-900 mb-3 h-10 flex items-center">Kvalita práce</h3>
                  <p className="text-gray-600 text-xs leading-relaxed flex-grow">Kvalitní materiály a moderní technologie</p>
                </div>
                
                <div className="bg-gray-50 rounded-lg p-4 flex flex-col h-full">
                  <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center mb-3 flex-shrink-0">
                    <i className="ri-time-line text-white text-lg"></i>
                  </div>
                  <h3 className="text-base font-semibold text-gray-900 mb-3 h-10 flex items-center">Rychlost</h3>
                  <p className="text-gray-600 text-xs leading-relaxed flex-grow">Rychlé řešení a dodržování termínů</p>
                </div>
                
                <div className="bg-gray-50 rounded-lg p-4 flex flex-col h-full">
                  <div className="w-10 h-10 bg-orange-600 rounded-lg flex items-center justify-center mb-3 flex-shrink-0">
                    <i className="ri-customer-service-line text-white text-lg"></i>
                  </div>
                  <h3 className="text-base font-semibold text-gray-900 mb-3 h-10 flex items-start leading-tight">Individuální přístup</h3>
                  <p className="text-gray-600 text-xs leading-relaxed flex-grow">Ke každému zákazníkovi individuálně</p>
                </div>
                
                <div className="bg-gray-50 rounded-lg p-4 flex flex-col h-full">
                  <div className="w-10 h-10 bg-red-600 rounded-lg flex items-center justify-center mb-3 flex-shrink-0">
                    <i className="ri-shield-check-line text-white text-lg"></i>
                  </div>
                  <h3 className="text-base font-semibold text-gray-900 mb-3 h-10 flex items-center">Spolehlivost</h3>
                  <p className="text-gray-600 text-xs leading-relaxed flex-grow">Dlouholeté zkušenosti a spokojenost</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-16 bg-blue-50 rounded-xl p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                <strong>Spolupráce s KUPA fotbalu</strong>
              </h3>
              <p className="text-gray-700 mb-4">
                V průběhu roku 2024 jsme začali spolupracovat a podporovat organizaci KUPA fotbalu, 
                která realizuje fotbalové turnaje pro děti a mládež.
              </p>
              <p className="text-gray-700 mb-4">
                Jsme rádi, že můžeme podporovat děti ve sportu a v tom, co je baví.
              </p>
              <p className="text-gray-700">
                Samozřejmě se dětem postaráme i o teplo v šatně a teplou vodu :-)
              </p>
            </div>
            <div className="flex justify-center">
              <img 
                src="https://1ac8821fb5.cbaul-cdnwnd.com/5f8f6c4b9a2b379554dd4f1c410a859a/200000047-c4d7dc4d81/700/kupa%20fotbal.webp?ph=1ac8821fb5" 
                alt="Spolupráce s KUPA fotbalu" 
                className="rounded-lg shadow-lg max-w-md w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
